import React, { useState } from 'react';
import styled from 'styled-components';
import { Link, useHistory } from 'react-router-dom';

import server from 'server/serverController2';
import GroupCommunityIconbtnpage from './GroupCommunityIconbtnpage';
import DotButton from 'components/presenters/button/DotButton';
import BottomModal from 'components/presenters/modal/BottomModal';
import appInfoContainer from '../../../../auth/appInfoContainer';
import { replaceTextURLToLink } from 'utils/utils.js';

const type = {
  free_topic: '자유글',
  review: '후기',
  greeting: '가입인사',
  info: '정보',
};

export default function GroupCommunityPhotoUploadDetail({
  likedeldataSubmit,
  likedataSubmit,
  background,
  border,
  borderwidth,
  borderline,
  margintop,
  comnum,
  path,
  link,
  item,
  setModalOption,
  setCurrentPostIndex,
  userInfo,
  isLikeAnimation,
  currentPostNo,
  isAdmin,
  setCommunityDetail
}) {
  const history = useHistory();

  const [visible, setVisible] = useState(false);
  const [dataList, setDataList] = useState([]);

  const deleteCommunityRequest = async (param) => {
    const deleteResult = await server.deleteRequestData(`groups/posts/${param}`);
    if(deleteResult['success'] === 1) {
      history.goBack();
    }
  }

  const pinDataRequest = async (param) => {
    let resultData;
    if(!param.pin) {
      resultData = await server.postRequestData(`groups/posts/${param.no}/pin`);
      if(resultData.success === 0) {
        return;
      }
    } else {
      resultData = await server.deleteRequestData(`groups/posts/${param.no}/pin`)
      if(resultData.success === 0) {
        return;
      }
    }
    const {updated_item} = resultData.data
    item['pin'] = updated_item[0].pin;
    setCommunityDetail([item]);
    setVisible(false);
  }

  const handleModal = (e) => { 
    if(isAdmin) {
      if(item['user_no'] === userInfo['id']) {
        setDataList([
          {type: 'callback', text: item.pin ? '핀삭제' :'핀고정', callback: pinDataRequest, callbackParam: item, style: {}},
          {type: 'redirect', text: '글수정',path: `/group/community/post/${item['no']}/edit`, style: {}}, 
          {type: 'callback', text: '삭제',callback: deleteCommunityRequest, callbackParam: currentPostNo, style: { color: '#DE0000'}}
        ])
      } else {
        setDataList([
          {type: 'callback', text: item.pin ? '핀삭제' :'핀고정', callback: pinDataRequest, callbackParam: item, style: {}},
          {type: 'callback', text: '삭제',callback: deleteCommunityRequest, callbackParam: currentPostNo, style: { color: '#DE0000'}}
        ])
      }
    } else {
        setDataList([
         {type: 'redirect', text: '글수정',path: `/CommunityWrite/${item['no']}`, style: {}}, 
         {type: 'callback', text: '삭제',callback: deleteCommunityRequest, callbackParam: currentPostNo, style: { color: '#DE0000'}}
        ])
    }
    setVisible(true);
  }
  //날짜 출력 폼 형태 시간 포함
  function getDateTimeType(date, second) {
    function checkZero(checkString) {
      return checkString.toString().length === 1
        ? '0' + checkString
        : checkString;
    }
    var temp =
      `${checkZero(date.getFullYear())}/${checkZero(
        date.getMonth() + 1,
      )}/${checkZero(date.getDate())},` +
      ` ${checkZero(date.getHours())}:${checkZero(date.getMinutes())} ${
        second ? ':' + checkZero(date.getSeconds()) : ''
      } `;
    return temp;
  }
  //시간 변환
  // var date;
  let date = getDateTimeType(new Date(item.create_date), false);
  let content = replaceTextURLToLink(item.content);
  return (
    <WriteDoneInner
      border={border}
      background={background}
      style={{ background: item.pin ? '#ffefce' : '#fff' }}
    >
      <UserWrite>
        <UserWriteBar>
          <UserImg>
            <Images
              src={
                appInfoContainer.imagePath +
                '/user_profile_img/' +
                item.profile_img
              }
            />
          </UserImg>
          <UserWriteDay>
            <UserNameZone>
              <UserName>{item.nickname}</UserName>
            </UserNameZone>
            <When>
              <span>{date}</span>
            </When>
          </UserWriteDay>
        </UserWriteBar>
        <BtDot>
          <Free_wt_bt>{type[item.post_type]}</Free_wt_bt>
          {item.user_no === userInfo.id  ? (
            <DotButton onClick={handleModal} style={{marginLeft: 'calc(100vw * (15 / 375))'}}/>
          )
           : null }
        </BtDot>
      </UserWrite>

      {link ? (
        <Link to={link} style={{ width: '100%' }}>
          <UserWriteCont>{content}</UserWriteCont>
          {item.img_attachment
            ? item.img_attachment.map((value) => {
                return (
                  <Upload_img>
                    <img
                      src={
                        appInfoContainer.imagePath + '/group_post_img/' + value
                      }
                    />
                  </Upload_img>
                );
              })
            : null}
        </Link>
      ) : (
        <span style={{ width: '100%' }}>
          <UserWriteCont>{content}</UserWriteCont>
          {item.img_attachment
            ? item.img_attachment.map((value) => {
                return (
                  <Upload_img>
                    <img
                      src={
                        appInfoContainer.imagePath + '/group_post_img/' + value
                      }
                    />
                  </Upload_img>
                );
              })
            : null}
        </span>
      )}

      <GroupCommunityIconbtnpage
        borderwidth={borderwidth}
        borderline={borderline}
        margintop={margintop}
        comnum={comnum}
        length={item.total_comment}
        heartnum={item.total_like}
        no={item.no}
        group_no={item.group_no}
        likedataSubmit={likedataSubmit}
        likedeldataSubmit={likedeldataSubmit}
        item={item}
        isLikeAnimation={isLikeAnimation}
        currentPostNo={currentPostNo}
      />

     <BottomModal visible={visible} setVisible={setVisible} dataList={dataList}/>
    </WriteDoneInner>
  );
}

const Images = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const WriteDoneInner = styled.div`
  margin-top: calc(100vw * (14 / 375));
  width: 100%;
  border-radius: calc(100vw * (5 / 375));
  // border: solid calc(100vw*(1/375)) #eaeaea;
  background-color: #ffffff;
  padding: calc(100vw * (8 / 375)) calc(100vw * (12 / 375))
  calc(100vw * (5 / 375)) calc(100vw * (10 / 375));
  border: ${({ border }) => border};
  background-color: ${({ background }) => background};
`;
const UserImg = styled.span`
  display: block;
  width: calc(100vw * (42 / 375));
  height: calc(100vw * (42 / 375));
  border-radius: 50%;
  border: solid calc(100vw * (1 / 375)) #c6c6c6;
  overflow: hidden;
`;
const UserNameZone = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: calc(100vw * (3.9 / 375));
`;
const UserWriteDay = styled.ul`
  margin-left: calc(100vw * (10 / 375));
`;
const UserName = styled.em`
  display: block;
  font-size: calc(100vw * (14 / 375));
  font-weight: bold;
`;
const UserWrite = styled.ul`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: calc(100vw * (10 / 375));
`;
const UserWriteBar = styled.li`
  display: flex;
  align-items: center;
`;

const Free_wt_bt = styled.a`
  width: calc(100vw * (74 / 375));
  height: calc(100vw * (26 / 375));
  border-radius: calc(100vw * (5 / 375));
  background-color: #1d1d1d;
  font-size: calc(100vw * (12 / 375));
  font-weight: 500;
  line-height: calc(100vw * (26 / 375));
  text-align: center;
  color: #ffffff;
`;
const Dot = styled.span`
  position: relative;
  display: block;
  width: calc(100vw * (4 / 375));
  height: calc(100vw * (4 / 375));
  background: rgb(41, 39, 36, 0.4);
  border-radius: 50%;
  margin-left: calc(100vw * (10 / 375));

  &::before {
    content: '';
    position: absolute;
    top: calc(100vw * (-7 / 375));
    left: 0;
    display: block;
    width: calc(100vw * (4 / 375));
    height: calc(100vw * (4 / 375));
    background: rgb(41, 39, 36, 0.4);
    border-radius: 50%;
  }
  &::after {
    content: '';
    position: absolute;
    top: calc(100vw * (7 / 375));
    left: 0;
    display: block;
    width: calc(100vw * (4 / 375));
    height: calc(100vw * (4 / 375));
    background: rgb(41, 39, 36, 0.4);
    border-radius: 50%;
  }
`;
const BtDot = styled.li`
  display: flex;
  align-items: center;
`;
const When = styled.li`
  font-size: calc(100vw * (12 / 375));
  color: #989898;

  & > span {
    color: #989898;
  }
`;

const UserWriteCont = styled.p`
  & > a {
    color: blue;
    text-decoration: underline;
  }

  font-size: calc(100vw * (14 / 375));
  line-height: 1.5;
  color: #1d1d1d;
  white-space: pre-wrap;
  word-break: break-all;
`;

const Upload_img = styled.a`
  width: 100%;
  margin-top: calc(100vw * (8 / 375));
`;
